import { render, staticRenderFns } from "./SeminarTrailer.vue?vue&type=template&id=22c7e528&scoped=true&"
import script from "./SeminarTrailer.vue?vue&type=script&lang=js&"
export * from "./SeminarTrailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c7e528",
  null
  
)

export default component.exports